import React, { createContext, useContext, useState } from 'react';

const HelpContext = createContext({
    helpModeOn: false, toggleHelp: () => {}, setHelpModeOn: () => {},
    subview: null, setSubview: () => {},
});

function HelpProvider({ children }) {
    const [helpModeOn, setHelpModeOn] = useState(false);
    const toggleHelp = () => setHelpModeOn(v => !v);
    // Lets a route with more than one distinct layout (e.g. Tavern's 3D scene vs. its 2D
    // dashboard, both at "/tavern") tell the overlay which hotspot set actually applies right
    // now — every other view just never calls this, so it stays null and pathname alone decides.
    const [subview, setSubview] = useState(null);

    return (
        <HelpContext.Provider value={{ helpModeOn, toggleHelp, setHelpModeOn, subview, setSubview }}>
            {children}
        </HelpContext.Provider>
    );
}

function useHelp() {
    return useContext(HelpContext);
}

export { HelpContext, HelpProvider, useHelp };
